import { render, staticRenderFns } from "./TitleFeature.vue?vue&type=template&id=a763d6b0&scoped=true&"
import script from "./TitleFeature.vue?vue&type=script&lang=ts&"
export * from "./TitleFeature.vue?vue&type=script&lang=ts&"
import style0 from "./TitleFeature.vue?vue&type=style&index=0&id=a763d6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a763d6b0",
  null
  
)

component.options.__file = "TitleFeature.vue"
export default component.exports